const config = { 
  gapi: {
    'apiKey': 'AIzaSyA50js6ZOLt9UwwpLEQ7aAayLguLb7Idj0',
    'clientId': '391376682624-mb743o3o7b9rglo4r74nue77s7lcs9av.apps.googleusercontent.com',
    'scope': 'https://www.googleapis.com/auth/userinfo.email',
    'discoveryDocs': [
      'https://api-dot-ao-billing-platform.appspot.com/_ah/api/discovery/v1/apis/billing/v1/rest'
    ]
  },
  debug: false
}

export default config;


// WEBPACK FOOTER //
// ./src/config.production.js